import type { FaireProductEntity } from "../../entity_types/product";

export const p_gucc9kwu7p: FaireProductEntity = {
  token: "p_gucc9kwu7p",
  type: "product",
  name: "Winter Lights 500 Piece Foil Puzzle by Galison",
  brandToken: "b_xhktv33sen",
  brandName: "Chronicle Books",
  imageUrl:
    "https://cdn.faire.com/fastly/f849f524463fe3b95c824216d4c0c7c616bce16d6ba4db908d826a3966fdc2cc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9571a36f0619ef2be9956a4fd49a2600ee9d9429715960633c78442d4ba295e9.jpeg",
    "https://cdn.faire.com/fastly/3c1fd62427520de5edecfce708323b1c6790052d1015774f21f728a84831ecb6.jpeg",
  ],
  priceDollars: 7.79,
  description:
    '#1 selling Holiday Puzzle of ALL TIME!  When you piece together the Winter Lights Foil 500 piece puzzle from Galison you reveal a fun night time image of a vibrant city all lit up and decorated for the holiday season. Art by best selling artist Joy Laforme.  \n - Package: 8 x 8 x 2"\n - Complete puzzle: 20 x 20"\n - Includes insert with information about the artist and image',
  tags: [],
  msrpDollars: 14.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:29.538Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
